import { render, staticRenderFns } from "./ChangeParent.vue?vue&type=template&id=8c09fb8e&scoped=true&"
import script from "./ChangeParent.vue?vue&type=script&lang=js&"
export * from "./ChangeParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c09fb8e",
  null
  
)

export default component.exports